import { render, staticRenderFns } from "./ethics-first.vue?vue&type=template&id=a6ae8490"
import script from "./ethics-first.vue?vue&type=script&lang=js"
export * from "./ethics-first.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports